export enum SapDayNumbers{
    Day1 = 1,
    Day2 = 2,
    Day3 = 3,
    Day4 = 4,
    Day6 = 6
}